export default "__VITE_ASSET__47d88c1a__"